import { gql } from '@apollo/client';

export const GET_WMS_PROGRESS = gql`
  query GetWmsProgress($filter: WmsProgressFilterInput!) {
    getWmsProgress(filter: $filter) {
      sortingCode
      key
      hub
      whs
      area
      dspName
      total
      unPackNum
      packNum
      abnormalNum
      returnNum
      level
      children {
        sortingCode
        key
        hub
        whs
        area
        dspName
        total
        unPackNum
        packNum
        abnormalNum
        returnNum
        level
        children {
          sortingCode
          key
          hub
          whs
          area
          dspName
          total
          unPackNum
          packNum
          abnormalNum
          returnNum
          level
        }
      }
    }
  }
`;

export interface WmsProgressType {
  sortingCode: string;
  key: string;
  hub: string;
  whs: string;
  area: string;
  dspName?: string;
  total: number;
  unPackNum: number;
  packNum: number;
  abnormalNum: number;
  returnNum: number;
  level: string;
  children: WmsProgressType[];
}

export interface WmsProgressFilterInput {
  channelId?: number;
  currentWarehouseId: number; // 必传参数
  arrivedCurrentWarehouseDateRange?: {
    start: string;
    end: string;
  };
  carrierCode?: number;
}

export interface GetWmsProgressResponse {
  getWmsProgress: WmsProgressType[];
} 